import { render, staticRenderFns } from "./ListOrShow.vue?vue&type=template&id=5579eb4c&"
import script from "./ListOrShow.vue?vue&type=script&lang=js&"
export * from "./ListOrShow.vue?vue&type=script&lang=js&"
import style0 from "./ListOrShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports